module.exports = __webpack_public_path__ + "static/media/list-view.9fda62bf.svg";